module.exports = "/_next/static/images/Cover@2x-e35cc87b6d6ec479c91792efc740d1ff.png";